import * as React from "react";
import styled from "styled-components";
import Panel from "../core/Panel";
import { useEffect, useState } from "react";
import jfetch from "../../utils/jfetch";

const RELEASE_CHECK_RATE = 180 * 1000;

const NewReleaseDiv = styled.div`
  position: fixed;
  bottom: 0;
  right: 10px;
  z-index: 10;
`;

interface IProps {
  pageRelease: string;
}

function NewReleaseChecker({ pageRelease }: IProps) {
  const [currentRelease, setCurrentRelease] = useState(pageRelease);

  useEffect(() => {
    const interval = setInterval(() => {
      // jfetch
      //   .get("/api/core/current_release")
      //   .then(result => {
      //     setCurrentRelease(result.release);
      //     // if (result.release !== pageRelease) {
      //     //   console.log(
      //     //     "New Release Detected:",
      //     //     result.release,
      //     //     "Previous Release:",
      //     //     pageRelease
      //     //   );
      //     // }
      //   })
      //   .catch(e => {
      //     // just eat the failure here
      //   });
    }, RELEASE_CHECK_RATE);

    return () => clearInterval(interval);
  }, []);

  if (pageRelease === currentRelease) {
    return null;
  } else {
    return (
      <NewReleaseDiv>
        <Panel heading={"New Update Detected"} type={"warning"}>
          <p>
            CORE has been updated, please refresh to ensure you are running the
            latest version.
          </p>
          <button
            className={"btn btn-theme-primary"}
            onClick={() => location.reload()}
          >
            <i className="fa fa-refresh" /> Refresh
          </button>
        </Panel>
      </NewReleaseDiv>
    );
  }
}

export default NewReleaseChecker;



// WEBPACK FOOTER //
// ./app/javascript/components/preloaded/NewReleaseChecker.tsx